import React from 'react';

import { AICoachGoalDecisionType } from 'enums/AICoach';

import CreditScoreProgressCircle from './CreditScoreProgressCircle';
import MonetaryProgressCircle from './MonetaryProgressCircle';

type GoalProgressCircleProps = {
  percentage: number;
  type: AICoachGoalDecisionType;
  value: number;
};

const GoalProgressCircle: React.FC<GoalProgressCircleProps> = (props) => {
  const { type } = props;

  // Credit score goal uses CreditScoreProgressCircle, all others use MonetaryProgressCircle
  const GoalComponent =
    type === AICoachGoalDecisionType.ImproveCreditScore ? CreditScoreProgressCircle : MonetaryProgressCircle;

  return <GoalComponent {...props} />;
};

export default GoalProgressCircle;
